import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HandleErrorsComponent } from './handle-errors.component';
import { ModalModule } from '../../../shared/errors/modal/modal.module';

@NgModule({
  declarations: [HandleErrorsComponent],
  exports: [HandleErrorsComponent],
  imports: [CommonModule, PortalModule, ModalModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HandleErrorModule {}
